import { render, staticRenderFns } from "./PromoCodeInput.vue?vue&type=template&id=189f2638&scoped=true&"
import script from "./PromoCodeInput.vue?vue&type=script&lang=js&"
export * from "./PromoCodeInput.vue?vue&type=script&lang=js&"
import style0 from "./PromoCodeInput.vue?vue&type=style&index=0&id=189f2638&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189f2638",
  null
  
)

export default component.exports